import moment from "moment/moment";

export const formatDate = (date: string) => {
    const lang = localStorage.getItem("lang")
    return moment(date).locale(lang ? lang : 'en').add(lang === 'th'
        ? 543 : 0, 'year').format("DD MMMM YYYY HH:MM A")
}

